import { Popover, PopoverContent, PopoverTrigger } from '@/components/design-system/popover';
import type { MenuItem } from '@/consts/navigation';
import { useTranslation } from 'react-i18next';

import { NavMenuItemsList } from './NavMenuItemsList';

interface NavHoverPopoverProps {
  item: MenuItem;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
}

export const NavHoverPopover = ({ item, isOpen, onOpenChange, children }: NavHoverPopoverProps) => {
  const { t } = useTranslation();
  const hasChildren = item.children && item.children.length > 0;

  if (!hasChildren) {
    return <>{children}</>;
  }

  return (
    <Popover open={isOpen} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        side="right"
        align="start"
        sideOffset={8}
        collisionPadding={{ top: 20, left: 20, bottom: 20 }}
        className="border-border-500 bg-secondary-900 max-h-[400px] min-w-[180px] overflow-y-auto rounded-md border p-1"
        onPointerDownOutside={(e) => {
          e.preventDefault();
        }}
      >
        <div className="border-border-500 bg-secondary-800 flex items-center rounded-t-md border-b px-3 py-2">
          <p className="text-typography-200 flex-1 overflow-hidden text-[10px] font-semibold tracking-wider text-ellipsis whitespace-nowrap uppercase">
            {t(item.text)}
          </p>
        </div>

        <NavMenuItemsList
          items={item.children ?? []}
          variant="popover"
          isUtilitySection={item.text === 'navigation.recent.title' || item.text === 'navigation.favorites.title'}
        />
      </PopoverContent>
    </Popover>
  );
};
